module.exports = __webpack_public_path__ + "img/VerySatisfied.ab1ca714.png";